import { render } from "./CreatorPicker.vue?vue&type=template&id=35a0dfaa"
import script from "./CreatorPicker.vue?vue&type=script&lang=js"
export * from "./CreatorPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__